import { useEffect, useMemo, useState } from 'react';
import cn from 'classnames';
import { Checkbox, CheckboxGroup, Grid } from 'ht-styleguide';

/* Store */
import { useHomeHubStoreActions } from '@scenes/HomeHub/store/client/homehub.store';

/* Hooks */
import useHomeHubAnswerController from '@scenes/HomeHub/hooks/hook.answerController';

/* Utils & Constants */
import { getGridColumnDetails } from '../utils';
import { COLUMN_WIDTHS } from '../constants';

/* Types */
import { TQuestionAnswer, TSelectedAnswer } from '@scenes/HomeHub/homehub.types';

import styles from '../selectors.module.scss';

// todo - fix selected type after data info is known.
const CheckboxSelectorGroup = () => {
  /* Store */
  const { setSelectedAnswersClientTransient } = useHomeHubStoreActions();

  /* Query hook */
  const { answers, selectedAnswers, gridColumn, answerSchemaNormalizer } = useHomeHubAnswerController();
  const answerIdValues = selectedAnswers.map((answer: TSelectedAnswer) => answer.home_survey_answer_id);

  /* Hooks */
  const [values, setValues] = useState<string[] | number[]>(answerIdValues);
  const showInput = useMemo(() => values.some(value => value === 'other'), [values]);

  /* ---- METHODS ----- */
  const onSelectorChange = (selected: string[] | number[]) => {
    setValues(selected);
  };

  useEffect(() => {
    const formattedAnswers = answerSchemaNormalizer.selectedAnswers({ selectedAnswers }).write(values);

    setSelectedAnswersClientTransient(formattedAnswers);
  }, [values, answerSchemaNormalizer, selectedAnswers, setSelectedAnswersClientTransient]);

  const { lgColumn, lgColumnOffset, mdColumn, mdColumnOffset } = getGridColumnDetails(gridColumn);

  return (
    <Grid.Fluid classes={styles.gridContainer}>
      <Grid.Row>
        <Grid.Column sm={4} md={mdColumn} mdOffset={mdColumnOffset} lg={lgColumn} lgOffset={lgColumnOffset}>
          <CheckboxGroup onChange={onSelectorChange} value={values} columnClassName={styles.radioGroup}>
            {answers.map((option: TQuestionAnswer) => {
              const isOtherSelected = option.value === 'other';
              const showInputfield = isOtherSelected && showInput;
              const checkboxStyles = cn(styles.commonCheckboxContainer, {
                [styles.grid1]: gridColumn === COLUMN_WIDTHS.ONE_COLUMN,
                [styles.grid2]: gridColumn === COLUMN_WIDTHS.TWO_COLUMNS,
                [styles.grid3]: gridColumn === COLUMN_WIDTHS.THREE_COLUMNS,
                [styles.checkboxInput]: showInputfield,
              });
              return (
                <div className={checkboxStyles} key={option.id}>
                  {!showInputfield && <Checkbox value={option.id} label={option.text} wrapperClass={styles.checkbox} />}
                  {/* showInputfield ? (
                    <InputField
                      onChange={onInputChange}
                      iconName="close"
                      iconOnClick={onIconClose}
                      elementSize={ELEMENT_SIZE.L}
                      inputWrapperClass={styles.checkboxInputPanel}
                      placeholder="Please specify"
                    />
                  ) : null */}
                </div>
              );
            })}
          </CheckboxGroup>
        </Grid.Column>
      </Grid.Row>
    </Grid.Fluid>
  );
};

export default CheckboxSelectorGroup;
